import { computed, ref, type WritableComputedRef } from 'vue'

interface ScrollPositionInstance {
  scrollX: WritableComputedRef<number | null>
  scrollY: WritableComputedRef<number | null>
}

const instances = new Map<string, ScrollPositionInstance>()

function createScrollPositionInstance(): ScrollPositionInstance {
  const x = ref<number | null>(null)
  const y = ref<number | null>(null)

  const scrollX = computed({
    get: () => x.value,
    set: (value: number | null) => {
      x.value = value
    }
  })

  const scrollY = computed({
    get: () => y.value,
    set: (value: number | null) => {
      y.value = value
    }
  })

  return { scrollX, scrollY }
}

function createAndStoreInstance(id: string) {
  const instance = createScrollPositionInstance()
  instances.set(id, instance)
  return instance
}

export function useScrollPosition(id: string): ScrollPositionInstance {
  return instances.get(id) ?? createAndStoreInstance(id)
}

export function destroyScrollPositionInstance(id: string): void {
  instances.delete(id)
}
